import React from "react";
import Navbar from "../../../component/Navbar";
import Footer from "../../../component/Footer";
import CountdownComponent from "../../../component/CountdownComponent";

const pickedTherapist = JSON.parse(localStorage.getItem("pickedTherapist"));
function Chat() {
  return (
    <div class="bg-[#FFFFFF]">
      <Navbar />
      <section
        id="therapist-menu"
        className="flex w-full justify-between gap-6 mt-[30px] mb-[40px] text-[#2A5801] pl-[30px] h-[600px] relative"
      >
        <div className="pt-[20px] pb-[20px] bg-[#DCAE96] w-[35%] rounded-[10px]  px-[20px]">
          <p className="text-lg font-semibold">Current Therapist</p>
          <div className="flex bg-white rounded-[10px] p-[10px] mt-[10px] w-full">
            <img
              className="w-12 h-12 rounded-full"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrBp4rAadRiXmk6NWl3redkvGJgWGDkBT4vA&usqp=CAU"
              alt="current therapist"
            />
            <div>
              <div className="flex">
                <h2 className="ml-[30px]">
                  {pickedTherapist.user.lastName[0]}. &nbsp;
                  {pickedTherapist.user.firstName}
                </h2>
                <img
                  className="ml-[42px] mt-[7px] w-[8px] h-[8px]"
                  src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701722601/Ellipse_40_aq2xym.png"
                  alt="green dot"
                />
              </div>
              <br />
              <h3 className="ml-[10px] mt-[-20px] text-[14px]">
                {pickedTherapist.specialization}
              </h3>
            </div>
          </div>
          {/* <div className="mt-[20px]">
            <p className="mt[0px]">Previous Therapists</p>
            <div className="flex bg-white rounded-[10px] p-[10px] mt-[10px]">
              <img
                className="w-12 h-12 rounded-full"
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1700513418/sue40dii2kkn1slpmlgb.jpg"
                alt="profile icon"
              />
              <div>
                <div className="flex">
                  <h2 className="ml-[30px]">K. WAJUD</h2>
                  <img
                    className="ml-[42px] mt-[7px] w-[8px] h-[8px]"
                    src="images/Ellipse yellow.png"
                    alt
                  />
                </div>
                <br />
                <h3 className="ml-[10px] mt-[-20px] text-[14px]">
                  Senior At Therapy
                </h3>
              </div>
            </div>
          </div> */}
          {/* <div className="flex bg-white rounded-[10px] p-[10px] mt-[20px]">
            <img
              className="w-12 h-12 rounded-full"
              src="https://res.cloudinary.com/deofacwik/image/upload/v1694602402/ladyyy_i1q0qa.jpg"
              alt="rahmat"
            />
            <div>
              <div className="flex">
                <h2 className="ml-[30px]">P. RAHMAH</h2>
                <img
                  className="ml-[30px] mt-[7px] w-[8px] h-[8px]"
                  src="images/Ellipse 42-1.png"
                  alt
                />
              </div>{" "}
              <br />
              <h3 className="ml-[10px] mt-[-20px] text-[14px]">
                Senior At Therapy
              </h3>
            </div>
          </div> */}
        </div>
        {/* Chat Area */}

        {/*Messages*/}
        <div className="relative flex flex-col pr-8  w-full">
          {/*count down time*/}
          <div className="self-end">
            <h1
              id="countdown"
              className="flex justify-end text-[#E60E1BCC] font-semibold text-[48px] pr-8"
            >
              <CountdownComponent />
            </h1>
          </div>
          <div
            id="messages"
            className="flex bg-[#295700] rounded-[10px] w-[300px] h-[60px] mb-[30px]"
          >
            <h2 className="text-[#D4DDCC] py-2 px-4 m-1">
              When depression creeps in
            </h2>
          </div>
          <div className="self-end   bg-[#DCAE96] rounded-[10px] w-[300px] h-[60px] mb-[30px] ">
            <h2 className="text-[#000000] py-2 px-4 m-1">
              in, you gradually start losing it.
            </h2>
          </div>
          <div className=" flex  bg-[#295700] rounded-[10px] w-[300px] h-[70px] mb-[30px]">
            <h2 className="text-[#D4DDCC] py-2 px-4 m-1">
              When depression creeps in, you gradually
            </h2>
          </div>
          <div className=" self-end bg-[#DCAE96] rounded-[10px] w-[300px] h-[70px] mb-[30px]">
            <h2 className="text-[#000000] py-2 px-4 m-1">
              When depression creeps in, you gradually start losing it.
            </h2>
          </div>
          {/* Type Message & Submit */}
          <div>
            <input
              type="text"
              id="messageInput"
              className=" block w-full bg-[#DCAE96] rounded-[10px] text-[#000000] focus:border-[#FFFFFF] text-sm flex-grow p-3 mt-40"
              placeholder="| Type Message"
            />
          </div>
        </div>

        {/* Message Locked */}
        {/* <div id="messageLocked" className="flex pl-[250px]"> */}
        {/* <img src="images/Locklock.png" alt="chatLocked" /> */}
        {/* <h2 className="text-[#000000] text-[18px]">
              Your Session Has Ended. Kindly book another session to continue
            </h2> */}
        {/* </div> */}
      </section>
      <Footer />
    </div>
  );
}

export default Chat;
